@import '~style-sheet-helpers/core.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@deleteWidth: 30px;

.store-alias,
.alias-header {
  > div {
    padding: 10px;
    flex: 1;
  }
  .alias-delete {
    width: @deleteWidth;
    height: 100%;
    flex: none;
    padding: 0;
  }
  .alias-input {
    padding: 0 20px 0 0;
    height: 35px;

    Input {
      .input-border-base-style();
    }
  }
}

.store-alias-list {
  min-height: 300px;
  overflow-y: auto;
}

.store-alias {
  display: flex;
  padding: 5px 10px;
  .store-selector {
    padding: 0 10px 0 0;

    select {
      padding: 5px;
    }
  }
}

.alias-header {
  display: flex;
  width: 100%;
  border-bottom: 1px solid @product-page--alias-header--border-color;
  padding: 0 5px;
  margin-bottom: 10px;
  > div:last-child {
    margin-left: -@deleteWidth;
  }
}

.delete-item {
  place-self: center center;
  cursor: pointer;
  height: 100%;
  svg {
    fill: @product-page--alias-delete--icon-color;
    transform: scale(0.5);
  }
  &:hover {
    svg {
      fill: @product-page--alias-delete--hover--icon-color;
    }
  }
}

.modal-body {
  padding: 30px;
  font-size: 17px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.bottom-padded {
  padding-bottom: 30px;
}

.small-bottom-padded {
  padding-bottom: 5px;
}

.alias-list-empty {
  text-align: center;
  width: 100%;
  margin: 20px 0;
}

.alias-add-button {
  width: 100%;
  display: flex;
  margin-top: 10px;
  > button {
    margin: 0 auto;
  }
}
